import React from "react";
import { NameCon } from "../styles/home";
import { ExperienceContainer } from "../styles/experience";

const Experience = () => {
  return (
    <ExperienceContainer>
      <div>
        <NameCon>
          <p>Experiencesss</p>
        </NameCon>
        <h1>I blend creativity with technical expertise</h1>
        <p>
          I’m dedicated to crafting websites that bring your ideas to life,
          combining design and development to deliver fast, impactful results.
        </p>
        <button>BOOK A CALL</button>
      </div>
      <div></div>
    </ExperienceContainer>
  );
};

export default Experience;
